import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UploadFileService } from '../../../store/upload-file/upload-file.service.facade';
import { filter, map } from 'rxjs/operators';
import { Observable, withLatestFrom } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ConfigurationService } from '../../../service/configuration.service';
import { NotificationService } from '../../../store/notification/notification.service';
import {
  NotificationStatus,
  NotificationType,
} from '../../../store/notification/types';
import { TranslateService } from '@ngx-translate/core';
import { documentSelectors } from '../../../store/document/document.selector';
import { Store } from '@ngrx/store';
import { documentActions } from '../../../store/document/document.actions';
import { DocumentService } from '../../../store/document/document.service';

@UntilDestroy()
@Component({
    selector: 'app-document-add',
    templateUrl: './document-add.component.html',
    styleUrls: ['./document-add.component.scss'],
    standalone: false
})
export class DocumentAddComponent implements OnInit {
  @Input() entityType: string;
  @Input() entityId: string;
  @Input() documentId: number = -1;
  @Input() multiple: boolean = false;
  @Output() newDocument = new EventEmitter<boolean>();
  @ViewChild('fileupload') fileupload: ElementRef<HTMLInputElement>;

  uploadCompleted$: Observable<boolean>;

  acceptFiles: string;

  constructor(
    private readonly uploadFileService: UploadFileService,
    private readonly notificationService: NotificationService,
    private readonly configurationService: ConfigurationService,
    private readonly translateService: TranslateService,
    private readonly store: Store,
  ) {}

  ngOnInit(): void {
    //Quand l'upload est fini, on refresh la liste
    this.uploadCompleted$ = this.uploadFileService.completed$.pipe(
      withLatestFrom(this.uploadFileService.currentFileId$),
      filter(([_isInProgress, id]) => this.documentId == id),
      map(([isInProgress, _id]) => isInProgress),
      untilDestroyed(this),
    );

    this.uploadCompleted$.subscribe((x) => {
      if (x) {
        this.newDocument.emit(true);
        this.store.dispatch(documentActions.getByEntityId.refresh());
      }
      this.reset();
    });

    this.acceptFiles = this.configurationService
      .getAutorizedFileExtensions()
      .join(',');
  }

  onFileSelected = (event) => {
    let files = event.target.files as File[];

    if (files.length > parseInt(this.configurationService.getMaxFiles())) {
      this.notificationService.add({
        timestamp: new Date().getTime(),
        content: this.translateService.instant('DOCUMENT_MSG_ERROR_MAX_FILES', {
          max: this.configurationService.getMaxFiles(),
        }),
        notificationStatus: NotificationStatus.Error,
        userCancelled: false,
        type: NotificationType.Toast,
        customNotification: false,
      });
      this.reset();
    }

    for (let i = 0; i < files.length; i++) {
      let file: File = files[i];

      if (file) {
        if (file.size == 0) {
          this.notificationService.add({
            timestamp: new Date().getTime(),
            content: this.translateService.instant(
              'DOCUMENT_MSG_ERROR_EMPTY_FILE',
              {
                fileName: file.name,
              },
            ),
            notificationStatus: NotificationStatus.Error,
            userCancelled: false,
            type: NotificationType.Toast,
            customNotification: false,
          });
          this.reset();
        } else if (
          file.size >
          parseInt(this.configurationService.getMaxSize()) * 1024 * 1024
        ) {
          this.notificationService.add({
            timestamp: new Date().getTime(),
            content: this.translateService.instant(
              'DOCUMENT_MSG_ERROR_MAX_SIZE',
              {
                fileName: file.name,
                max: this.configurationService.getMaxSize(),
              },
            ),
            notificationStatus: NotificationStatus.Error,
            userCancelled: false,
            type: NotificationType.Toast,
            customNotification: false,
          });
          this.reset();
        } else {
          this.uploadFileService.uploadFile(
            this.documentId,
            this.entityType,
            this.entityId,
            file,
          );
        }
      }
    }
  };

  cancelUpload = () => {
    this.uploadFileService.cancelUpload();
    this.reset();
  };

  reset = () => {
    if (this.fileupload?.nativeElement) {
      this.fileupload.nativeElement.value = '';
    }
    this.uploadFileService.resetUpload();
  };

  delete = () => {
    // var message = this.translateService.instant(
    //   'WALLET_PASSENGER_DOCUMENT_DELETE'
    // );
    // this.messageService.openConfirmation(message).then((yes) => {
    //   if (yes) {
    //     this.walletService.deleteFile.call(this.document.id);
    //   }
    // });
  };
}
